<script lang="ts">
  import { onMount } from 'svelte';

  let isClamped = true;
  let contentRef: HTMLParagraphElement;
  let isOverflowing = false;

  function toggleClamp() {
    isClamped = !isClamped;
  }

  onMount(() => {
    // Check if content is overflowing
    const checkOverflow = () => {
      if (contentRef) {
        const lineHeight = parseInt(window.getComputedStyle(contentRef).lineHeight);
        const maxHeight = lineHeight * 2; // 2 lines as per line-clamp-2
        isOverflowing = contentRef.scrollHeight > maxHeight;
      }
    };

    checkOverflow();
    // Recheck on window resize
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  });
</script>

<p
  bind:this={contentRef}
  class="mt-4 max-w-lg text-base md:text-lg text-slate-700"
  class:line-clamp-2={isClamped}
>
  <slot />
</p>
{#if isOverflowing}
  <button type="button" class="text-xs text-indigo-500 font-medium" on:click={toggleClamp}>
    {isClamped ? 'Show More' : 'Show Less'}
  </button>
{/if}
